import { ArrowVerticalLockIcon } from './ArrowVerticalLockIcon';

/**
 * author: Michael Irigoyen
 * id 8B00DF03-0754-4D7F-B0C9-8CF21D42989F
 * name arrow-vertical-lock
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-vertical-lock.svg
 * tags
 * - Lock 
 * - Arrow 
 */
export const ScrollVerticalLockIcon = ArrowVerticalLockIcon;
export default ScrollVerticalLockIcon